'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import ViewIcon from "material-ui-icons/RemoveRedEye";


var TopicBlogView = (_temp2 = _class = function (_Component) {
  _inherits(TopicBlogView, _Component);

  function TopicBlogView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TopicBlogView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TopicBlogView.__proto__ || Object.getPrototypeOf(TopicBlogView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      opened: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TopicBlogView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _context = this.context,
          UserLink = _context.UserLink,
          Autocomplete = _context.Autocomplete;

      var _props = this.props,
          objects = _props.data.objects,
          value = _props.value,
          getFilters = _props.getFilters,
          setFilters = _props.setFilters,
          label = _props.label,
          helperText = _props.helperText,
          inputProps = _props.inputProps,
          _onClick = _props.onClick,
          other = _objectWithoutProperties(_props, ['data', 'value', 'getFilters', 'setFilters', 'label', 'helperText', 'inputProps', 'onClick']);

      var opened = this.state.opened;

      var _ref2 = getFilters() || {},
          search = _ref2.search;

      var items = objects && objects.map(function (n) {
        var fullname = n.fullname,
            username = n.username;
        var name = fullname || username;
        return _extends({}, n, {
          label: name
        });
      }) || [];
      var object = value ? items.find(function (n) {
        return n.id === value;
      }) : null;
      /**
       * Если есть id компании и нет введенного значения,
       * то выводим название компании
       */

      var displayValue = opened && search || object && object.label || value;
      return _react2.default.createElement(Autocomplete, _extends({
        inputProps: _extends({
          label: label,
          helperText: helperText
        }, inputProps),
        onChange: function onChange(event, value) {
          // this.setState({
          //   value: value,
          // }, () => {
          //   this.loadData();
          // });
          // onChange && onChange(event, value);
          setFilters({
            search: value && value.trim() || undefined
          });
        } // onSelect={(value, item) => {
        //   // this.loadObjectData(id);
        //   // this.setState({
        //   //   object: item,
        //   // }, () => {
        //   //   // onChange && onChange(item.id);
        //   //   onSelect && onSelect(value, item);
        //   // });
        // }}
        // onDelete={(event) => {
        //   updateObject({
        //     blogID: undefined,
        //   })
        // }}
        ,
        items: items,
        value: opened ? search || "" : displayValue || value || "",
        onMenuVisibilityChange: function onMenuVisibilityChange(opened) {
          // if (opened && !items.length) {
          //   this.loadData();
          // }
          _this2.setState({
            opened: opened
          }); // onMenuVisibilityChange && onMenuVisibilityChange(opened);

        } // getItemText={(item) => {
        //   const {
        //     value,
        //     label,
        //   } = item;
        //   return label;
        // }}
        // onSelect={(value, item) => {
        //   const {
        //     id,
        //   } = item;
        //   updateObject({
        //     blogID: id || undefined,
        //   })
        // }}
        ,
        getItemText: function getItemText(item) {
          return _react2.default.createElement(UserLink, {
            user: item,
            onClick: function onClick(event) {
              event.preventDefault();
              return _onClick ? _onClick(event) : null;
            }
          });
        },
        viewElement: !opened && object ? _react2.default.createElement(UserLink, {
          user: object,
          target: '_blank',
          size: 'small',
          showName: false
        }) : undefined
      }, other));
    }
  }]);

  return TopicBlogView;
}(_react.Component), _class.contextType = _context3.default, _class.propTypes = {
  getFilters: _propTypes2.default.func.isRequired,
  setFilters: _propTypes2.default.func.isRequired,
  label: _propTypes2.default.string,
  helperText: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  onClick: _propTypes2.default.func
}, _class.defaultProps = {
  label: "Пользователь",
  helperText: "Поиск по имени, логину и емейлу"
}, _temp2);
exports.default = TopicBlogView;
module.exports = exports['default'];